import { render, staticRenderFns } from "./FilterSongs.vue?vue&type=template&id=45aab9a2&scoped=true&"
import script from "./FilterSongs.vue?vue&type=script&lang=js&"
export * from "./FilterSongs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aab9a2",
  null
  
)

export default component.exports